import { IconGiveBack32, IconHome32, IconYourStyleHangerActive32, Text } from '@stitch-fix/mode-react';
import { CloudinaryImageV2 } from '../../../../../components/CSCloudinaryAsset/Image';
import { CloudinaryPicture } from '../../../../../components/CSCloudinaryAsset/Picture';
import type { BrandsValuePageData } from '../../types';
import styles from './index.module.scss';
interface StylistMatchSectionProps {
  data: BrandsValuePageData['stylistMatch'];
}
const IconByCard = {
  budget: IconGiveBack32,
  home: IconHome32,
  style: IconYourStyleHangerActive32
};
export const StylistMatchSection = ({
  data
}: StylistMatchSectionProps) => {
  const marqueeImages = ['first', 'second'].flatMap(cycle => data.outfitImages.map(image => ({
    ...image,
    marqueeId: `${cycle}-${image.id}`
  })));
  return <section className={styles.section}>
      <div className={styles.mediaStage}>
        <CloudinaryPicture alt={data.backgroundAlt} sources={[{
        minWidth: 0,
        cloudinaryAsset: data.backgroundMobileCloudinaryAsset,
        sizes: [{
          minWidth: 0,
          fluidWidth: 100
        }]
      }, {
        minWidth: 901,
        cloudinaryAsset: data.backgroundDesktopCloudinaryAsset,
        sizes: [{
          minWidth: 0,
          fluidWidth: 100
        }]
      }]} imageProps={{
        className: styles.backgroundImage,
        fetchPriority: 'high',
        loading: 'eager',
        style: {
          height: '100%',
          width: '100%'
        }
      }} pictureProps={{
        className: styles.backgroundPicture
      }} />
        <div className={styles.marquee} aria-hidden="true">
          <div className={styles.marqueeTrack}>
            {marqueeImages.map(image => <div className={styles.outfitCard} key={image.marqueeId}>
                <CloudinaryImageV2 alt="" cloudinaryAsset={image.cloudinaryAsset} imageProps={{
              className: styles.outfitImage,
              loading: 'lazy',
              style: {
                height: '100%',
                width: '100%'
              }
            }} sizes={[{
              minWidth: 0,
              staticWidth: 141
            }]} />
              </div>)}
          </div>
        </div>
        <div className={styles.foregroundFrame}>
          <CloudinaryImageV2 alt={data.foregroundAlt} cloudinaryAsset={data.foregroundCloudinaryAsset} imageProps={{
          className: styles.foregroundImage,
          loading: 'lazy',
          style: {
            height: '100%',
            width: 'auto'
          }
        }} sizes={[{
          minWidth: 0,
          staticWidth: 238
        }]} />
        </div>
      </div>

      <div className={styles.contentPanel}>
        <div className={styles.container}>
          <Text as="p" className={styles.eyebrow} setting="eyebrow-medium">
            {data.eyebrow}
          </Text>
          <Text as="h2" className={styles.title} setting="display-large">
            {data.title}
          </Text>
          <div className={styles.gridWrap}>
            <div className={styles.cardsGrid}>
              {data.cards.map(card => {
              const CardIcon = card.icon ? IconByCard[card.icon] : null;
              return <div className={styles.card} key={card.id}>
                    <div className={styles.iconBadge} aria-hidden="true">
                      {CardIcon ? <CardIcon className={styles.icon} purpose="decorative" /> : null}
                    </div>
                    <Text as="h3" className={styles.cardTitle} setting="title-small">
                      {card.title}
                    </Text>
                    <Text as="p" className={styles.cardDescription} setting="body-medium">
                      {card.description}
                    </Text>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
};